import { ConferencingType, ResponseStatusEnum, VideoLink } from "@clockwise/schema";
import { DateTime } from "luxon";
import { Profile } from "../../util/profile.util";
import { MEETING_LOCATION_DETAILS } from "../scheduling-confirmation/event-summary";

export const getEventPreviewFormattedTime = (time: DateTime) =>
  time.toFormat("h:mm a").replace(":00", "");

export const getConferencingIcon = (videoLink?: VideoLink | null) => {
  if (!videoLink || !videoLink?.type) {
    return MEETING_LOCATION_DETAILS["InDescription"].locationIcon;
  }

  // Google Meet
  if (videoLink.type === ConferencingType.MEET) {
    return MEETING_LOCATION_DETAILS["Meet"].locationIcon;
  }

  // Zoom
  if (videoLink.type === ConferencingType.ZOOM) {
    return MEETING_LOCATION_DETAILS["Zoom"].locationIcon;
  }

  // Teams
  if (videoLink.type === ConferencingType.TEAMS_FOR_BUSINESS) {
    return MEETING_LOCATION_DETAILS["Teams"].locationIcon;
  }

  return MEETING_LOCATION_DETAILS["InDescription"].locationIcon;
};

// Sort attendees by rsvp ResponseStatusEnum Accepted, Tentative, Declined, NeedsAction, NotApplicable then by givenName + familyName
export const sortAttendees = (
  attendees: { profile: Profile; rsvp?: ResponseStatusEnum | null }[],
) =>
  attendees.sort((a, b) => {
    if (a.rsvp === b.rsvp) {
      const aFull = `${a.profile.givenName || ""} ${a.profile.familyName || ""}`.trim();
      const bFull = `${b.profile.givenName || ""} ${b.profile.familyName || ""}`.trim();
      return aFull.localeCompare(bFull);
    }

    if (a.rsvp === ResponseStatusEnum.Accepted) {
      return -1;
    }
    if (b.rsvp === ResponseStatusEnum.Accepted) {
      return 1;
    }
    if (a.rsvp === ResponseStatusEnum.Tentative) {
      return -1;
    }
    if (b.rsvp === ResponseStatusEnum.Tentative) {
      return 1;
    }
    if (a.rsvp === ResponseStatusEnum.Declined) {
      return -1;
    }
    if (b.rsvp === ResponseStatusEnum.Declined) {
      return 1;
    }
    if (a.rsvp === ResponseStatusEnum.NeedsAction) {
      return -1;
    }
    if (b.rsvp === ResponseStatusEnum.NeedsAction) {
      return 1;
    }
    if (a.rsvp === ResponseStatusEnum.NotApplicable) {
      return -1;
    }
    if (b.rsvp === ResponseStatusEnum.NotApplicable) {
      return 1;
    }
    return 0;
  });
